/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { Epic } from 'redux-observable';
import initiateStore, { type Store } from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import rootReducer from './reducer/index.tsx';
import type { Action, State } from './types.tsx';

export const createStore = (rootEpic?: Epic<Action, State>): Store<State> =>
	initiateStore<State, Action, undefined>({
		appName: 'flags',
		rootReducer,
		rootEpic,
	});
